import { HTMLAttributes } from "react";
import { twMerge } from 'tailwind-merge'

interface TitleProps extends HTMLAttributes<HTMLSpanElement> {
    text?: string
}

export function Title({ text, ...rest }: TitleProps) {
    return (
        <span {...rest} className={twMerge("tw-text-[28px] tw-font-medium tw-text-[#565656]", rest.className)}>
            {text}
        </span>
    )
}